module.exports = __webpack_public_path__ + "img/fenxiang1.c03cca39.png";